import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { NumericTextboxModel } from '../numeric-textbox.model';

@Component({
    selector: 'abw-numeric-textbox-design',
    templateUrl: './numeric-textbox-design.component.html',
    styleUrls: ['./numeric-textbox-design.component.scss']
})
export class NumericTextboxDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: NumericTextboxModel;
    @Input() value: any;
    onComplete = new Subject();

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }
}